import { h, Component } from 'preact';

export default class TilesWidget extends Component {
	componentDidMount() {
		const {
			enableTilesWidget,
			tilesPubId,
			tileTheme,
			enableCarousel,
			bgConfig
		} = this.props?.tilesWidgetConfig || {};
		if (enableTilesWidget) {
			const script = document.createElement('script');
			script.type = 'module';
			script.src =
				this.props?.portalStaticOrigin + '/tilesWidget/tiles-widget.js';
			script.setAttribute('data-pubid', tilesPubId);
			script.setAttribute('data-theme', tileTheme);
			script.setAttribute('data-carousel', enableCarousel);
			script.setAttribute('data-bgconfig', JSON.stringify(bgConfig || {}));
			document.head.appendChild(script);
		}
	}

	render() {
		return (
			// eslint-disable-next-line react/self-closing-comp
			<div id="tiles-widget-container"></div>
		);
	}
}
